.g{flex-direction:column;}